var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog-main",
          attrs: {
            title: "档案详情",
            visible: _vm.dialogVisible,
            "modal-append-to-body": false,
            width: "650px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.closeDetail
          }
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            _vm._l(_vm.detailData, function(tabItem, tabIndex) {
              return _c(
                "el-tab-pane",
                {
                  key: tabIndex,
                  attrs: {
                    label:
                      tabItem.isDefault == 1
                        ? "默认档案"
                        : "档案" + (tabIndex + 1),
                    name: tabIndex + ""
                  }
                },
                [
                  _c("div", { staticClass: "container" }, [
                    _c("div", { staticClass: "header-wrap" }, [
                      _c("div", { staticClass: "personal-information" }, [
                        _c(
                          "div",
                          { staticClass: "avatar-wrap" },
                          [
                            _c("el-avatar", {
                              staticStyle: {
                                width: "60px",
                                height: "60px",
                                "box-shadow": "1px 1px 5px 1px #dfdfdf"
                              },
                              attrs: {
                                shape: "square",
                                src: _vm.detailItem.avatar
                              }
                            })
                          ],
                          1
                        ),
                        _c("div", { staticClass: "name-wrap" }, [
                          tabItem.ctmName != null
                            ? _c("div", { staticClass: "ctm-name" }, [
                                _vm._v(_vm._s(tabItem.ctmName) + " "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#E86452",
                                      "font-size": "13px"
                                    }
                                  },
                                  [_vm._v(" @宏脉")]
                                )
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#a09f9fc9",
                                "font-size": "13px"
                              }
                            },
                            [
                              _vm._v(_vm._s(_vm.detailItem.name)),
                              _vm.detailItem.type == 1
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: { color: "rgb(70, 189, 10)" }
                                    },
                                    [_vm._v(" @微信")]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticStyle: { color: "rgb(8, 168, 231)" }
                                    },
                                    [
                                      _vm._v(
                                        " @" + _vm._s(_vm.detailItem.corpName)
                                      )
                                    ]
                                  )
                            ]
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "other" }, [
                        _c("div", { staticClass: "other-li" }, [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(_vm._s("绑定时间"))
                          ]),
                          _c("div", { staticClass: "value" }, [
                            _vm._v(_vm._s(tabItem.bindTime))
                          ])
                        ]),
                        _c("div", { staticClass: "other-li" }, [
                          _c("div", { staticClass: "label" }, [
                            _vm._v("操作员工:")
                          ]),
                          _c("div", { staticClass: "value" }, [
                            _vm._v(_vm._s(tabItem.operationName))
                          ])
                        ])
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "main-message" },
                      _vm._l(tabItem.messageContainer, function(item, index) {
                        return _c(
                          "div",
                          { key: item.id, staticClass: "main-message-li" },
                          [
                            _c("div", { staticClass: "li-tilte" }, [
                              _vm._v(_vm._s(item.title))
                            ]),
                            _c(
                              "div",
                              { staticClass: "li-content" },
                              _vm._l(item.li, function(liItem, liIndex) {
                                return _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          item.id != 3 ||
                                          (item.id == 3 && liItem.label),
                                        expression:
                                          "(item.id != 3) || (item.id == 3 && liItem.label)"
                                      }
                                    ],
                                    key: liIndex,
                                    staticClass: "content-row"
                                  },
                                  [
                                    _c("div", { staticClass: "row-label" }, [
                                      _vm._v(_vm._s(liItem.label))
                                    ]),
                                    _c("div", [_vm._v(":")]),
                                    _c("div", { staticClass: "row-value" }, [
                                      _vm._v(_vm._s(liItem.value))
                                    ])
                                  ]
                                )
                              }),
                              0
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ]
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }